const colors = { MELON: '#02cd3b', GENIE: '#24b5e6', BUGS: '#ff3c28' };

const theme = { colors };

export default theme;
